import { render, staticRenderFns } from "./FormConsultation.vue?vue&type=template&id=b2a9d7d6&"
import script from "./FormConsultation.vue?vue&type=script&lang=ts&"
export * from "./FormConsultation.vue?vue&type=script&lang=ts&"
import style0 from "./FormConsultation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports